import { TFunction } from 'i18next';
import { Message } from '../../../../interfaces/Message';
import { MessageDto } from '../../../../interfaces/dtos/MessageDto';
import transformMessage from '../transformMessage/transformMessage';

export default function transformMessages(messagesDtos: MessageDto[], t: TFunction<'DetailsLoader'>): Message[] {
  const messages: Message[] = [];
  messagesDtos?.forEach((dto) => {
    if (dto) {
      messages.push(
        transformMessage(dto, t),
      );
    }
  });
  return messages;
}
